import StudentsRow from "./StudentsRow";
import { StudentsDTO } from "../../../api/Students/GetAllStudents";

const StudentsTable = ({ data }: { data?: StudentsDTO[] }) => {
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();
    const hours = date.getHours() % 12 || 12;
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const ampm = date.getHours() >= 12 ? "PM" : "AM";

    return `${day}.${month}.${year} - ${hours}:${minutes} ${ampm}`;
  };

  return (
    <div>
      <div className="overflow-x-auto scrollbar-thumb-blue scrollbar-thumb-rounded scrollbar-track-blue-lighter scrollbar-w-2 scrolling-touch">
        <table className="table-auto w-full">
          <thead className="text-lg capitalize ">
            <tr className="bg-[#F1F4F9] rounded-t-lg">
              <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                <div className="text-left text-sm">Full Name</div>
              </th>
              <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                <div className="text-left text-sm">Email</div>
              </th>
              <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                <div className="text-left text-sm">Country</div>
              </th>
              <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                <div className="text-left text-sm">Last Country</div>
              </th>
              <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                <div className="text-left text-sm">Last Visited</div>
              </th>
              <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                <div className="text-left text-sm">Joined At</div>
              </th>

              <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                <div className="text-left text-sm">Phone</div>
              </th>
              <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                <div className="text-left text-sm">Job Title</div>
              </th>
              <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                <div className="text-left text-sm">Birth Date</div>
              </th>

              <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                <div className="text-left text-sm">Status</div>
              </th>
              <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                <div className="text-left text-sm">Blocked</div>
              </th>
              <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                <div className="text-left text-sm">IP Exception</div>
              </th>
              <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                <div className="text-left text-sm">Actions</div>
              </th>
            </tr>
          </thead>
          <tbody className="text-sm">
            {data?.map((student: StudentsDTO) => (
              <StudentsRow
                key={student.id}
                id={student.id}
                country={student.country}
                img={student.img_url}
                fullName={`${student.firstName} ${student.lastName}`}
                phone={student.phone}
                lastCountry={student.lastCountry}
                email={student.email}
                status={student.status}
                jobTitle={student.jobTitle}
                lastVisited={
                  student.lastVisited ? formatDate(student.lastVisited) : ""
                }
                isBlocked={student.isBlocked}
                ipRestrictionException={student.ipRestrictionException}
                birthDate={student.birthDate}
                joinedAt={formatDate(student.createdAt)}
                studentId={student.id}
              />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default StudentsTable;
